// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js??ref--4-1!./multi_calendar.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("5de881ec", content, true);


//////////////////
// WEBPACK FOOTER
// ./static/material/global/css/multi_calendar.css
// module id = 1451
// module chunks = 0